const createExportData = (columns, rows, type) => {
  const columnMap = {};

  columns.forEach((column) => {
    if (column.disableExport) return;
    if (type === 'pdf' && column.disableExportPDF) return;
    if (type === 'csv' && column.disableExportCSV) return;
    columnMap[column.headerName] = column.field;
  });

  const headers = Object.keys(columnMap);

  const tableRows = rows.map((row) =>
    headers.map((header) => `${row?.[columnMap?.[header]]}`)
  );

  return [headers, tableRows];
};

export default createExportData;
